import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";
import { IControlPanelButtonProps } from "./ControlPanelButton.props";
import styles from "./ControlPanelButton.module.scss";
import useTranslate from "../../hooks/useTranslate";
import { backgroundColor } from "../../constants/colors";
import Hint from "../../HOC/Hint/Hint";
import { selectHintsEnabled } from "@/store/hintsSlice";
import { useAppSelector } from "@/store/hooks";

const ControlPanelButton = ({
	className,
	onClick,
	disabled,
	title,
	buttonSmallSize = false,
	icon,
	iconSize = "xl",
	disableDefaultIcon = false,
	isActive = false,
	isWarning = false,
	hint = "",
	hintOffset = [0, 0],
	hintPostion,
	...props
}: IControlPanelButtonProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста
	const hintEnabled = useAppSelector(selectHintsEnabled);

	return (
		<Hint hint={hint} position={hintPostion} offset={hintOffset}>
			<button
				className={cn(styles.button, className, {
					[styles.buttonSmallSize]: buttonSmallSize,
					[styles.active]: isActive,
					[styles.warning]: isWarning,
				})}
				onClick={onClick}
				disabled={disabled}
				title={hintEnabled ? "" : translate(title)}
				aria-label={translate(props["aria-label"] || title)}
				type="button"
				{...props}
			>
				{!disableDefaultIcon && <FontAwesomeIcon icon={icon} size={iconSize} color={backgroundColor} />}
				{props.children}
			</button>
		</Hint>
	);
};

export default ControlPanelButton;
